var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import VTButton from "../VTButton";
import VTTypography from "../VTTypography";
import VTMenu from "../VTMenu";
import { VTFilterButton } from "./VTFilterButton";
export default function VTLandingFilters(_a) {
    var _b;
    var filterValue = _a.filterValue, filters = _a.filters, sideDrawWidth = _a.sideDrawWidth, _c = _a.reactiveWidth, reactiveWidth = _c === void 0 ? 550 + filters.length * 200 : _c;
    var matches = useMediaQuery("(min-width:" + (reactiveWidth + sideDrawWidth) + "px)");
    var _d = __read(useState([]), 2), menuOptions = _d[0], setMenuOptions = _d[1];
    useEffect(function () {
        var tempArray = [];
        filters.forEach(function (element) {
            tempArray.push({
                component: (_jsx(VTButton, __assign({ type: "list", onClick: element.handleClick, startIcon: element.icon }, { children: element.title }))),
            });
        });
        setMenuOptions(tempArray);
    }, []);
    return (_jsx(Grid, __assign({ item: true, container: true, xs: 12, justifyContent: "center", sx: {
            position: "absolute",
            bottom: "-37px",
            marginRight: "-110px",
        } }, { children: matches ? (
        // If page is large render all buttons
        filters.map(function (element) { return (_jsx(VTFilterButton, { title: element.title, icon: element.icon, handleClick: element.handleClick, disabled: element.disabled, filterValue: filterValue })); })) : (
        // If page is to small give options as drop down
        _jsxs(Grid, __assign({ item: true, xs: 1, sx: {
                position: "relative",
                display: "flex",
                justifyContent: "center",
                height: "110px",
                marginRight: "100px",
                minWidth: "121px",
            } }, { children: [_jsx(VTTypography, __assign({ align: "center" }, { children: filterValue })), _jsx(VTMenu, __assign({ menuOptions: menuOptions, type: "avatar", sx: {
                        borderRadius: "50%",
                        position: "absolute",
                        bottom: 0,
                        width: "82px",
                        height: "82px",
                        fontSize: "1.4em",
                        "& .MuiAvatar-root": {
                            background: "linear-gradient(to bottom, #0ab5a7,#8e25fa)",
                            color: "#ffffff",
                            cursor: "pointer",
                            "&:hover": {
                                boxShadow: "0 0 15px #fff",
                                fontSize: "1em",
                            },
                        },
                    } }, { children: (_b = filters.find(function (element) { return element.title === filterValue; })) === null || _b === void 0 ? void 0 : _b.icon }))] }))) })));
}
